import { CapoPlugin } from "/home/sylvain/ybd/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];